/**
 * Enum representing the types of user events.
 */
export enum UserEventTypes {
  /**
   * To DLS as CUSTOM EVENTS
   */
  DOWNLOAD_INSTALLER = 'download-installer',
  REPORT_DOWNLOAD = 'report-download',
  COMPLETION_CERTIFICATE_DOWNLOAD = 'completion-certificate-download',
  /**
   * EXTERNAL S3 BUCKET
   */
  CONTENT_VIEWED = 'content-viewed',
  /**
   * To Cavallier
   */
  PAGE_VIEWED = 'page-viewed',
  USER_ACTION_PERFORMED = 'user-action-performed',
  EBOOK_TOOL_LAUNCHED = 'ebook-tool-launched',
  EBOOK_HOTSPOT_LAUNCH = 'ebook-hotspot-launch',
  DESKTOP_EBOOK_DOWNLOAD_STARTED = 'desktop-ebook-download-started',
  DESKTOP_EBOOK_DOWNLOAD_ENDED = 'desktop-ebook-download-ended',
  DESKTOP_SESSION_STARTED = 'desktop-session-started',
  DESKTOP_SESSION_COMPLETED = 'desktop-session-completed',
  DESKTOP_READER_OPENED = 'desktop-reader-opened',
  DESKTOP_READER_CLOSED = 'desktop-reader-closed'
}
